import styled from 'styled-components'
import SearchList, { SearchListWrapper } from '../components/SearchList'
import { TitleButton } from '../components/TitleButton'
import LabelOnly from '../components/LabelOnly'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
`

const Body = styled.div`
  display: flex;
  padding: 24px;
  gap: 40px;
`
const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: fit-content;
`

const GraphFrame = styled.div`
  padding: 0px 0px 0px 10px;
`

const GraphWrapper = styled.div`
  display: flex;
  width: 620.99px;
  height: 120px;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`
const GraphBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`

const LabelTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const TableWrapper = styled.div`
  padding: 0px 0px 0px 10px;
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid transparent;
`

const TableRow = styled.div`
  display: flex;
`

interface TableGrayProps {
  white?: boolean
}

const TableCell = styled.div<TableGrayProps>`
  display: flex;
  width: 122.8px;
  height: 38px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`
const TableCell2 = styled.div<TableGrayProps>`
  display: flex;
  width: 102.8px;
  height: 20px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
`

const OptionFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

const OptionListWrapper = styled.div`
  display: flex;
  padding-left: 10px;
  width: 100%;
  align-items: flex-start;
  gap: 16px;
`

const OptionDetailWrapper = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

const OptionDetailBox = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  gap: 4px;
`
const Rectangle = styled.div`
  width: 4px;
  height: 14px;
  border-radius: 99px;
  background: var(--green100, #57c9a7);
`
const OptionTextBox = styled.div`
  padding-top: 1px;
  width: max-content;
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`

const DetailFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
const DetailWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
const DetailColWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-left: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
const SubText = styled.div`
  color: var(--gray90, #333);
  text-align: center;
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
const SubTextUnit = styled.div`
  color: var(--gray90, #333);
  font-family: SUIT;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
const TableTitleFrame = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
const CustomerNameWrapper = styled.div`
  display: flex;
  padding: 6px 8px;
  align-items: center;
  border-radius: 4px 4px 0px 0px;
  background: var(--green100, #57c9a7);
`

const CustomerName = styled.div`
  color: var(--gray10, #fff);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const PlanName = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const SalesPlanCheck = () => {
  return (
    <>
      <SearchListWrapper>
        <SearchList />
      </SearchListWrapper>
      <ContentWrapper>
        <Header>
          <TitleButton title="홍길동 고객 - 000요금제"></TitleButton>
        </Header>
        <Body>
          <Left>
            <DetailFrame>
              <LabelOnly label="시간대 그래프" />
              <DetailColWrapper>
                <GraphWrapper>
                  <GraphBody>그래프</GraphBody>
                </GraphWrapper>
                <Table>
                  <TableRow>
                    <TableCell
                      style={{ borderTopLeftRadius: '4px' }}
                    ></TableCell>
                    <TableCell>봄</TableCell>
                    <TableCell>여름</TableCell>
                    <TableCell>가을</TableCell>
                    <TableCell style={{ borderTopRightRadius: '4px' }}>
                      겨울
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>경부하</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>중간부하</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderBottomLeftRadius: '4px' }}>
                      최대부하
                    </TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white>0</TableCell>
                    <TableCell white style={{ borderBottomRightRadius: '4px' }}>
                      0
                    </TableCell>
                  </TableRow>
                </Table>
              </DetailColWrapper>
            </DetailFrame>
            <OptionFrame>
              <LabelOnly label="선택한 옵션 목록" />
              <OptionListWrapper>
                <OptionDetailWrapper>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>한전 요금제 : </OptionTextBox>
                    <OptionTextBox>23.01.01 개정</OptionTextBox>
                  </OptionDetailBox>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>공휴일 정보 : </OptionTextBox>
                    <OptionTextBox>2023년 공휴일</OptionTextBox>
                  </OptionDetailBox>
                </OptionDetailWrapper>
                {/* 구분선*/}
                <OptionDetailWrapper>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>고객 전력 구매 비율 : </OptionTextBox>
                    <OptionTextBox>50</OptionTextBox>
                  </OptionDetailBox>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>변경될 한전과의 계약 전력 : </OptionTextBox>
                    <OptionTextBox>500kW</OptionTextBox>
                  </OptionDetailBox>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>RE100 달성 여부 : </OptionTextBox>
                    <OptionTextBox>미달성</OptionTextBox>
                  </OptionDetailBox>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>녹색 프리미엄 단가 : </OptionTextBox>
                    <OptionTextBox>11원</OptionTextBox>
                  </OptionDetailBox>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>고객 이익 가중치 비율 : </OptionTextBox>
                    <OptionTextBox>50</OptionTextBox>
                  </OptionDetailBox>
                  <OptionDetailBox>
                    <Rectangle />
                    <OptionTextBox>비용 옵션 : </OptionTextBox>
                    <OptionTextBox>PV 구입비용만 반영</OptionTextBox>
                  </OptionDetailBox>
                </OptionDetailWrapper>
              </OptionListWrapper>
            </OptionFrame>
          </Left>

          <Right>
            <DetailFrame>
              <LabelOnly label="PV 구입비용 및 단가" />
              <DetailColWrapper>
                <Table>
                  <TableTitleFrame>
                    <CustomerNameWrapper>
                      <CustomerName>홍길동 고객</CustomerName>
                    </CustomerNameWrapper>
                    <PlanName>요금제 이름</PlanName>
                  </TableTitleFrame>
                  <TableRow>
                    <TableCell2></TableCell2>
                    <TableCell2>봄</TableCell2>
                    <TableCell2>여름</TableCell2>
                    <TableCell2>가을</TableCell2>
                    <TableCell2>겨울</TableCell2>
                    <TableCell2 style={{ borderTopRightRadius: '4px' }}>
                      총
                    </TableCell2>
                  </TableRow>
                  <TableRow>
                    <TableCell2>발전량</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                  </TableRow>
                  <TableRow>
                    <TableCell2>PV 구입비용</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                  </TableRow>
                  <TableRow>
                    <TableCell2 style={{ borderBottomLeftRadius: '4px' }}>
                      <SubText>
                        PV 단가 {'\n'}
                        <SubTextUnit> (원/kWh)</SubTextUnit>
                      </SubText>
                    </TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2
                      white
                      style={{ borderBottomRightRadius: '4px' }}
                    >
                      0
                    </TableCell2>
                  </TableRow>
                </Table>
                <Table>
                  <TableTitleFrame>
                    <CustomerNameWrapper>
                      <CustomerName>홍길동 고객</CustomerName>
                    </CustomerNameWrapper>
                    <PlanName>요금제 이름</PlanName>
                  </TableTitleFrame>
                  {/* 여기다가*/}
                  <TableRow>
                    <TableCell2></TableCell2>
                    <TableCell2>봄</TableCell2>
                    <TableCell2>여름</TableCell2>
                    <TableCell2>가을</TableCell2>
                    <TableCell2>겨울</TableCell2>
                    <TableCell2 style={{ borderTopRightRadius: '4px' }}>
                      총
                    </TableCell2>
                  </TableRow>
                  <TableRow>
                    <TableCell2>발전량</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                  </TableRow>
                  <TableRow>
                    <TableCell2>PV 구입비용</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                  </TableRow>
                  <TableRow>
                    <TableCell2 style={{ borderBottomLeftRadius: '4px' }}>
                      <SubText>
                        PV 단가 {'\n'}
                        <SubTextUnit> (원/kWh)</SubTextUnit>
                      </SubText>
                    </TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2 white>0</TableCell2>
                    <TableCell2
                      white
                      style={{ borderBottomRightRadius: '4px' }}
                    >
                      0
                    </TableCell2>
                  </TableRow>
                </Table>
              </DetailColWrapper>
            </DetailFrame>
          </Right>
        </Body>
      </ContentWrapper>
    </>
  )
}
